'use client'

import { useNavContext } from './nav-context-provider'
import { useMenuComponent } from './use-menu-component'

const loadSheet = () => import('./sheet/nav-mobile-sheet').then((module) => module.NavMobileSheet)

// Keep the sheet's CSS and interaction code out of the initial public shell.
// Warm it on nav intent, or fetch immediately when the visitor opens the menu.
export const NavMobileSheetMount = () => {
  const { isMobile, isMobileMenuVisible, current } = useNavContext()
  const open = isMobile && (isMobileMenuVisible || !!current.containerId)
  const NavMobileSheet = useMenuComponent(isMobile, open, loadSheet)

  // Prepare it while closed and retain it through exit animations and cleanup.
  if (!isMobile || !NavMobileSheet) {
    return null
  }

  return <NavMobileSheet />
}
